export default "__VITE_ASSET__DALKe3X5__"